/**
 * Environment Configuration - Runtime Detection
 *
 * Centralise TOUTE la config environnementale avec détection runtime par hostname.
 * Résout le problème : npm run build utilise .env.production pour TOUS les déploiements
 * (beta ET production), donc on ne peut pas se fier aux variables d'env build-time
 * pour distinguer beta de prod.
 *
 * Hostnames :
 * - Production : app.raskmote.com, raskmote-prod.web.app
 * - Beta : beta-raskmote.web.app
 * - Dev : localhost, 127.0.0.1
 */

// ─── Hostname Detection ───────────────────────────────────────────────────────

const PROD_HOSTNAMES = ['app.raskmote.com', 'raskmote-prod.web.app'];
const BETA_HOSTNAMES = ['beta-raskmote.web.app'];
const DEV_HOSTNAMES = ['localhost', '127.0.0.1'];

const hostname = typeof window !== 'undefined' ? window.location.hostname : '';

export const ENV = {
  isProd: PROD_HOSTNAMES.includes(hostname),
  isBeta: BETA_HOSTNAMES.includes(hostname),
  isDev: DEV_HOSTNAMES.includes(hostname),
  hostname,
};

// Fallback : si aucun hostname reconnu, on considère beta par défaut (safe)
if (!ENV.isProd && !ENV.isBeta && !ENV.isDev) {
  ENV.isBeta = true;
}

export const ENV_NAME = ENV.isProd ? 'production' : ENV.isBeta ? 'beta' : 'development';

// ─── Firebase Config ──────────────────────────────────────────────────────────

const firebaseConfigBeta = {
  apiKey: "AIzaSyBn6jdb97lxsW3O7h8IM5z3T9sfwAK2Sa8",
  authDomain: "raskmote.firebaseapp.com",
  databaseURL: "https://raskmote-default-rtdb.firebaseio.com",
  projectId: "raskmote",
  storageBucket: "raskmote.appspot.com",
  messagingSenderId: "458165262402",
  appId: "1:458165262402:web:3a81c426b502cd15adf5db",
  measurementId: "G-S57DBMD6HD"
};

const firebaseConfigProd = {
  apiKey: "AIzaSyBSdeHGIkL2hnJK7XQlmzbVDKEP3HRNEcE",
  authDomain: "raskmote-prod.firebaseapp.com",
  projectId: "raskmote-prod",
  storageBucket: "raskmote-prod.firebasestorage.app",
  messagingSenderId: "39845752466",
  appId: "1:39845752466:web:39af29848930487404c04b",
  measurementId: "G-F2C3RFHL4D"
};

export const firebaseConfig = ENV.isProd ? firebaseConfigProd : firebaseConfigBeta;

// ─── Backend URLs ─────────────────────────────────────────────────────────────

const BACKEND_URLS = {
  production: 'https://raskmote-backend-prod-39845752466.europe-west1.run.app',
  beta: 'https://raskmote-backend-458165262402.europe-west1.run.app',
  development: 'http://localhost:3001',
};

export const BACKEND_URL = ENV.isProd
  ? BACKEND_URLS.production
  : ENV.isDev
    ? BACKEND_URLS.development
    : BACKEND_URLS.beta;

// ─── Cloud Functions URLs ─────────────────────────────────────────────────────

const CLOUD_FUNCTIONS_URLS = {
  production: 'https://us-central1-raskmote-prod.cloudfunctions.net/api',
  beta: 'https://us-central1-raskmote.cloudfunctions.net/api',
  development: 'http://127.0.0.1:5001/raskmote/us-central1/api',
};

export const CLOUD_FUNCTIONS_URL = ENV.isProd
  ? CLOUD_FUNCTIONS_URLS.production
  : ENV.isDev
    ? CLOUD_FUNCTIONS_URLS.development
    : CLOUD_FUNCTIONS_URLS.beta;

// ─── Debug (dev only) ─────────────────────────────────────────────────────────

if (ENV.isDev) {
  console.log(`[ENV] Environment: ${ENV_NAME} | Hostname: ${hostname}`);
  console.log(`[ENV] Firebase project: ${firebaseConfig.projectId}`);
  console.log(`[ENV] Backend URL: ${BACKEND_URL}`);
}
